import { formatShortDateTime, maskKey } from "../format";

function formatTimestamp(value) {
  return formatShortDateTime(value);
}

export function normalizeMethod(method) {
  return String(method || "GET").toUpperCase();
}

export function mapApiEndpointToIntent(item) {
  const method = normalizeMethod(item.method);
  const isActive = Boolean(item.is_active);

  return {
    id: String(item.id),
    orgId: item.org_id,
    name: item.name || "Unnamed Intent",
    description: item.description || "No description provided.",
    method,
    endpointUrl: item.endpoint_url || "N/A",
    status: isActive ? "Active" : "Disabled",
    isActive,
    authKey: item.auth_key || "",
    authKeyMasked: item.auth_key ? maskKey(item.auth_key) : "N/A",
    metaData: item.meta_data,
    createdAt: formatTimestamp(item.created_at),
    updatedAt: formatTimestamp(item.updated_at),
    keywords: [method, item.endpoint_url].filter(Boolean),
  };
}
